import template from './field-new-modal.pug';

export const FieldNewModalComponent = {
  template,
  bindings:{
    resolve: '<',
    modalInstance: '<',
  },
  controller: class FieldNewModalComponent {
    constructor($translate, $async, $log, CustomField) {
      'ngInject';
      this.$translate = $translate;
      this.$log = $log;
      this.CustomField = CustomField;
      this.save = $async(this.save.bind(this));
      this.loadGroups = $async(this.loadGroups.bind(this));
      this.fields = this.CustomField.fieldList;
    }

    $onInit() {
      this.group = this.resolve.group;
      this.recordType = this.group.generic_module;
      this.loadGroups();
    }

    async loadGroups() {
      try {
        this.cfGroups = await this.CustomField.loadGroups({ module: this.recordType });
        if (this.group.id == undefined && this.cfGroups.length > 0) {
          this.group = this.cfGroups[0];
        }
      } catch (e) {
        this.$log.error(e);
      }
    }

    async save({ field }) {

      if (this.group.id == undefined) {
        this.group = await this.CustomField.newGroup(
          { title: 'Main info', generic_module: this.group.generic_module });
      }

      const params = {
        ...field,
        custom_fields_group_id: this.group.id
      };
      try {
        this.loader = true;
        const field =  await this.CustomField.newField(params);
        this.modalInstance.close(field);
      } catch (e) {
        this.$log.error(e);
      } finally {
        this.loader = false;
      }
    }

    resolveTitle() {
      let title;
      if (this.selectedField) {
        title = this.selectedField.name;
      } else {
        title = `${this.$translate.instant('custom_fields.select_field_type')}`;
      }
      return title;
    }

    close() {
      this.modalInstance.close(void(0));
    }
  }
};
